import {
    ComponentFactoryResolver,
    ComponentRef,
    ViewContainerRef,
    Injectable
} from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ViewService, BreadCrumbService } from '.';
import { CtBarFilterComponent, CtBarButtonComponent, CtBodyComponent, CtButtonComponent, CtColumnComponent, CtContentItemComponent, CtDialogComponent, CtEmailFormComponent, CtFormComponent, CtHeaderComponent, CtInputCheckBoxComponent, CtInputTextComponent, CtLabelComponent, CtPanelComponent, CtPreviewComponent, CtrlBaseComponent, CtRowComponent, CtSelectComponent, CtTabComponent, CtViewComponent, CtFormListComponent, CtTableComponent, CtInputNumberComponent, CtStepperComponent, CtInputFileComponent, CtTextareaComponent, CtSidebarComponent, CtBannerComponent, CtTimelineComponent, CtInputDateComponent, CtFilterWindowComponent, CtFilterContainerComponent, CtCustomSelect, CtInputRadioGroupComponent, CtRadioComponent, CtMessageComponent, CtMessageContainerComponent, CtProgressBarComponent, CtRegexComponent, CtRadioContainerComponent, CtAnchorComponent, CtRecaptchaComponent, CtOtpComponent, CtButtonCompressedContainerComponent, CtReceiptComponent, CtDividerComponent, CtFooterComponent, CtButtonUncompressedContainerComponent, CtCardComponent } from '../controls';
import { CtStepperItemComponent } from '../controls/ct-stepper-item/ct-stepper-item.component';
import { AppState, ViewModel } from '../models';

@Injectable()
export class PaintService {

    public currentView: ViewModel;
    public rootModel: CtViewComponent;
    public componentRef: ComponentRef<any>;
    public vViewComponents = {};
    public viewId = "";

    private controls = {
        // Containers
        'CtView': CtViewComponent,
        'CtHeader': CtHeaderComponent,
        'CtBody': CtBodyComponent,
        'CtRow': CtRowComponent,
        'CtColumn': CtColumnComponent,
        'CtBarFilter': CtBarFilterComponent,
        'CtBarButton': CtBarButtonComponent,
        'CtPanel': CtPanelComponent,
        'CtForm': CtFormComponent,
        'CtTab': CtTabComponent,
        'CtContentItem': CtContentItemComponent,
        'CtDialog': CtDialogComponent,
        'CtFormList': CtFormListComponent,
        'CtStepper': CtStepperComponent,
        'CtStepperItem': CtStepperItemComponent,
        'CtSidebar': CtSidebarComponent,
        'CtTimeline': CtTimelineComponent,
        'CtFooter': CtFooterComponent,

        // Data
        'CtPreview': CtPreviewComponent,
        'CtTable': CtTableComponent,
        'CtFilterWindow': CtFilterWindowComponent,
        'CtFilterContainer': CtFilterContainerComponent,

        // Visual
        'CtButton': CtButtonComponent,
        'CtLabel': CtLabelComponent,
        'CtBanner': CtBannerComponent,
        'CtInputRadioGroup':CtInputRadioGroupComponent,
        'CtRadio': CtRadioComponent,
        'CtProgressBar': CtProgressBarComponent,
        'CtRadioContainer':CtRadioContainerComponent,

        // Inputs
        'CtSelect': CtSelectComponent,
        'CtEmailForm': CtEmailFormComponent,
        'CtInputText': CtInputTextComponent,
        'CtInputNumber': CtInputNumberComponent,
        'CtInputCheckBox': CtInputCheckBoxComponent,
        'CtInputFile': CtInputFileComponent,
        'CtTextArea': CtTextareaComponent,
        'CtInputDate': CtInputDateComponent,
        'CtCustomSelect': CtCustomSelect,
        'CtMessage': CtMessageComponent,
        'CtMessageContainer': CtMessageContainerComponent,
        'CtRegex': CtRegexComponent,
        'CtReCaptcha': CtRecaptchaComponent,
        'CtAnchor': CtAnchorComponent,
        'CtOtp': CtOtpComponent,
        'CtButtonCompressedContainer': CtButtonCompressedContainerComponent,
        'CtReceipt': CtReceiptComponent,
        'CtButtonUncompressedContainer' : CtButtonUncompressedContainerComponent,
        'CtDivider': CtDividerComponent,
        'CtCard' : CtCardComponent
    };

    constructor(private viewService: ViewService,/* private notificationsService: NotificationsService,*/ private breadcrumbService: BreadCrumbService, private viewStore: Store<AppState>) {
        this.viewStore.select(store => store).subscribe((state: any) => {
            this.currentView = state.currentView;
        });
    }

    paintChildren(controlModel: any, comp: ComponentFactoryResolver, target: ViewContainerRef): any {
        return this.processChildren(controlModel, comp, target);
    }

    paintChildrenV2(viewId: string, comp: ComponentFactoryResolver, target: ViewContainerRef): any {
        let cachedView = this.breadcrumbService.getCachedView(viewId);
        this.rootModel = null;

        if (!cachedView)
            cachedView = this.viewService.getViewById(viewId);
        else {
            let viewBehavior = new BehaviorSubject<any>({});
            let observableView = viewBehavior.asObservable();
            viewBehavior.next(cachedView.node);
            cachedView = observableView;
        }

        return cachedView.pipe(
            map((controlModel: any) => {
                return this.processChildren(controlModel, comp, target);
            }));
    }

    paintChildrenV3(viewId: string, comp: ComponentFactoryResolver, target: ViewContainerRef, callback: (response: any) => void, fallback?: (error: Error) => void, isAsync: boolean = false): number {
        let cachedView = this.breadcrumbService.getCachedView(viewId);
        let requestId: number = null;

        if (cachedView)
            callback(this.processChildren(JSON.parse(cachedView.node), comp, target));
        else {
            requestId = this.viewService.requestViewById(viewId, (response) => {
                callback(this.processChildren(JSON.parse(response), comp, target));
            }, fallback, isAsync);
        }

        return requestId;
    }

    private processChildren(controlModel: any, comp: ComponentFactoryResolver, target: ViewContainerRef): CtrlBaseComponent[] {
        let childElements: CtrlBaseComponent[] = [];
        let components: any = this.controls;
        if (controlModel && controlModel.models) {
            if (controlModel.ctType === "CtView") {
                this.viewId = controlModel.controlProperties.id;
            }
            else if (Object.keys(components).length === 0 && components.constructor === Object) {
                components = this.vViewComponents;
                this.viewId = controlModel.models[0].controlProperties.id;

                controlModel.ctType = controlModel.models[0].controlProperties.id;

                var vEncapsulator = {
                    models: [controlModel]
                }

                controlModel = vEncapsulator;

            } else if (controlModel.compileVersion) {//Case for parent view node
                this.viewId = controlModel.models[0].controlProperties.id;
            }

            target.clear();

            for (let model of controlModel.models) {
                try {
                    let childComponent = components[model.ctType];
                    let componentFactory = comp.resolveComponentFactory(childComponent);
                    this.componentRef = target.createComponent(componentFactory);
                    this.componentRef.instance.metaData = model;
                    this.componentRef.instance.viewId = this.viewId;
                    childElements.push(this.componentRef.instance);

                    if (model.ctType === 'CtView' && !this.rootModel)
                        this.rootModel = this.componentRef.instance;
                    // if (model.ctType != 'CtTextArea')
                    this.componentRef.changeDetectorRef.detectChanges();
                } catch (e) {
                    console.log(model.ctType, e, model);
                }
            }
        }
        return childElements;
    }
}
